import {Outlet, Link} from "react-router-dom";

export default function Guest() {
    return (
        <div className="main-container">
            <Outlet />
        </div>
)
}